var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import createReactContext from 'create-react-context';
import format from './util.format';

// by default we want our consumers to just safely return the key provided
// to it, rather than exploding if not wrapped in a provider properly
export var Localize = createReactContext({
  localize: function localize(key) {
    return key;
  },
  debug: true,
  xLocale: false
});
export var useLocalize = function useLocalize() {
  if (!useContext) {
    console.warn('This feature is only available in React >= 16.8');
    return {};
  }
  return useContext(Localize);
};
export var LocalizationProvider = function (_React$Component) {
  _inherits(LocalizationProvider, _React$Component);
  function LocalizationProvider() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, LocalizationProvider);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LocalizationProvider.__proto__ || Object.getPrototypeOf(LocalizationProvider)).call.apply(_ref, [this].concat(args))), _this), _this._localize = function (key, values) {
      var _this$props = _this.props,
        localize = _this$props.localize,
        xLocale = _this$props.xLocale,
        messages = _this$props.messages,
        debug = _this$props.debug;
      var isLocalizeProvided = localize !== LocalizationProvider.defaultProps.localize;
      var localizeFn = localize;
      if (typeof localize !== 'function') {
        localizeFn = function localizeFn(messages, key) {
          if (debug) console.warn('Unable to localize ' + key + ', not connected to react-localize');
          return key;
        };
      }
      if (isLocalizeProvided) {
        // doing sanity checks against the inputs, lookup, debug, xLocale are only
        // supported for the default behavior, when users provide their own override
        // method we can defer that to them
        return localizeFn(messages, key, values, xLocale, debug);
      }
      if (!messages || !key) {
        if (debug) console.warn('Unable to localize missing messages or key in arguments.');
        return null;
      }
      var lookup = messages[key];
      if (!lookup && typeof lookup !== 'string') {
        if (debug) console.warn('Unable to localize missing messages or key in arguments for ' + key);
        return key;
      }
      if (xLocale) {
        return 'XXXXXX';
      }
      return localizeFn(messages, key, values);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(LocalizationProvider, [{
    key: 'render',
    value: function render() {
      var localize = this._localize;
      var _props = this.props,
        xLocale = _props.xLocale,
        debug = _props.debug;
      return React.createElement(Localize.Provider, {
        value: {
          localize: localize,
          xLocale: xLocale,
          debug: debug
        }
      }, this.props.children);
    }
  }]);
  return LocalizationProvider;
}(React.Component);
LocalizationProvider.propTypes = {
  children: PropTypes.node.isRequired,
  localize: PropTypes.func,
  messages: PropTypes.object.isRequired,
  xLocale: PropTypes.bool
};
LocalizationProvider.defaultProps = {
  debug: false,
  localize: function localize(messages, key) {
    var values = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if (values) {
      return format(messages[key], values);
    }
    return format(messages[key]);
  },
  xLocale: false
};
export var LocalizationConsumer = Localize.Consumer;